import axiosInstance from "../../../utils/axios";
import axios from "axios";
import { ROLE } from "../../../utils/Constants";

const path = "/advertiser"
const options = {role: ROLE.ADVERTISER};

export const getSocialMedia = async (values) => {
    return await axiosInstance(options).get(`${path}/social-media/get-social-medial-config`, values);
}

export const twitchConfigure = async (values) => {
    return await axiosInstance(options).put(`${path}/social-media/update-twitch-config`, values);
}

export const toggleSocialMedia = async (values) => {
    return await axiosInstance(options).put(`${path}/social-media/update-config`, values);
}
export const deleteSocialMediaConfig = async (values) => {
    return await axiosInstance(options).put(`${path}/social-media/delete-config-media`, values);
}
export const facebookAuthConfig = async (values) => {
    return await axiosInstance(options).post(`${path}/streams/facebook-auth`, values);
}
export const youtubeAuthConfig = async (values) => {
    return await axiosInstance(options).post(`${path}/streams/auth`, values);
}

/**
 * facebookCallback
 * Forwards the OAuth code (and state) from the URL query params to the backend.
 * The backend returns a server-side rendered HTML string.
 */
export const facebookCallback = async ({ code, state }) => {
    const baseURL = process.env.REACT_APP_API_URL;
    const params = new URLSearchParams({ code });
    if (state) params.append("state", state);
    // Use raw axios — no auth header needed, backend handles this as a public OAuth callback
    const response = await axios.get(
        `${baseURL}/webservice/api/v1/advertiser/streams/facebook/callback?${params.toString()}`,
        { responseType: "text" }
    );
    return response.data;
}